import { Controller } from "stimulus"

export default class extends Controller {

  connect() {
    this.updatePreview()
  }

  static targets = [
    'descriptionInput',
    'linkTextInput',
    'linkLocationInput',
    'colorInput',
    'description',
    'link',
    'container'
  ]

  updatePreview() {
    let description = this.descriptionInputTarget.value
    let link_text = this.linkTextInputTarget.value
    let link_location = this.linkLocationInputTarget.value
    let color = this.colorInputTarget.value
    this.descriptionTarget.innerHTML = description
    this.linkTarget.innerHTML = link_text
    this.linkTarget.href = link_location
    this.containerTarget.style.backgroundColor = color
  }
}
